import React from 'react'

const PrivacyPage: React.FC = () => {
  return (
    <div className="bg-gray-950 text-white min-h-screen">
      <div className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-4xl font-bold mb-8 gradient-text">Privacy Policy</h1>

        <div className="space-y-8 text-gray-300">
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-cyan-400">1. Introduction</h2>
            <p>
              At VisSynth, we are committed to protecting your privacy. This Privacy Policy explains how we handle information related to your use of our AI video generation service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-cyan-400">2. Information We Collect</h2>
            <p className="mb-4">We collect the following types of information:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li><strong>Account Information:</strong> Name, email address, and authentication credentials</li>
              <li><strong>Content Data:</strong> Video scripts, prompts, images, and generated videos</li>
              <li><strong>Usage Data:</strong> Browser type, operating system, device type, and screen resolution</li>
              <li><strong>Payment Information:</strong> Processed securely through third-party payment providers</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-cyan-400">3. How We Use Your Information</h2>
            <p className="mb-4">We use your information to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Provide and maintain our AI video generation service</li>
              <li>Process your video creation requests</li>
              <li>Send you notifications about your account and videos</li>
              <li>Process payments and manage subscriptions</li>
              <li>Improve our service and develop new features</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-cyan-400">4. Data Storage and Retention</h2>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Videos and content are stored according to your subscription plan</li>
              <li>Account data is retained until you request deletion</li>
              <li>You can request deletion of your data at any time through account settings</li>
              <li>We implement secure backup and disaster recovery measures</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-cyan-400">5. Data Security</h2>
            <p>
              We implement appropriate technical and organizational measures to ensure a level of security appropriate to the risk, including encryption of sensitive data, secure API communications, and regular security audits.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-cyan-400">6. Third-Party Services</h2>
            <p className="mb-4">VisSynth integrates with various third-party services:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li><strong>AI Model Providers:</strong> OpenAI, ElevenLabs, and other AI services</li>
              <li><strong>Cloud Storage:</strong> Secure cloud storage providers</li>
              <li><strong>Payment Processors:</strong> Stripe, PayPal, and other payment services</li>
              <li><strong>Social Platforms:</strong> TikTok, YouTube, and Instagram APIs</li>
            </ul>
            <p className="text-sm text-gray-400 mt-2">These services have their own privacy policies, which we encourage you to review.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-cyan-400">7. Your Rights and Choices</h2>
            <p className="mb-4">You have the right to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Access, download, and export your data</li>
              <li>Request deletion of your account and data</li>
              <li>Opt-out of marketing communications</li>
              <li>Manage your privacy preferences</li>
              <li>Revoke access to third-party integrations</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-cyan-400">8. Children's Privacy</h2>
            <p>
              Our service is not directed to children under the age of 13. We do not knowingly collect personal information from children under 13. If we become aware that we have collected such information, we will delete it immediately.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-cyan-400">9. Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the new policy on this page and updating the "Last updated" date.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-cyan-400">10. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us through our support channel or via email.
            </p>
          </section>

          <section className="text-sm text-gray-400 mt-12 pt-8 border-t border-gray-800">
            <p>Last updated: December 2025</p>
          </section>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPage
